/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseQueryItemType from './BaseQueryItemType';
import MoserObjectUtils from './MoserObjectUtils';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseQueryItemType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // updateShortcutSet
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}baseQueryItemType"&gt; &lt;sequence&gt; &lt;element name="concepts" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="minimumValue" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="maximumValue" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="numberOfDistinctValues" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="numberOfNullValues" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="orderedValues" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="hierarchyHasMultipleRoots" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="calculatedMember" type="{}calculatedMemberType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="rootMember" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="members" type="{}memberType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class QueryItem extends BaseQueryItemType{

	concepts = null;

	minimumValue = null;

	maximumValue = null;

	numberOfDistinctValues = null;

	numberOfNullValues = null;

	orderedValues = null;

	hierarchyHasMultipleRoots = null;

	calculatedMember = null;

	rootMember = null;

	members = null;



	/**
	 * Gets the value of the concepts property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the concepts property. <p> For example, to add a new item, do as follows: <pre> getConcepts().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getConcepts() {
		if (!this.concepts) {
			this.concepts = [];
		}
		return this.concepts;
	}

	/**
	 * Gets the value of the minimumValue property.
	 * @return {String} possible object is {@link String}
	 */
	getMinimumValue() {
		return this.minimumValue;
	}

	/**
	 * Sets the value of the minimumValue property.
	 * @param {String} value allowed object is {@link String}
	 */
	setMinimumValue(value) {
		var oldValue = this.minimumValue;
		this.minimumValue = value;
		this._setAndNotify(183, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 183, oldValue, value);
	}

	/**
	 * Gets the value of the maximumValue property.
	 * @return {String} possible object is {@link String}
	 */
	getMaximumValue() {
		return this.maximumValue;
	}

	/**
	 * Sets the value of the maximumValue property.
	 * @param {String} value allowed object is {@link String}
	 */
	setMaximumValue(value) {
		var oldValue = this.maximumValue;
		this.maximumValue = value;
		this._setAndNotify(184, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 184, oldValue, value);
	}

	/**
	 * Gets the value of the numberOfDistinctValues property.
	 * @return {String} possible object is {@link String}
	 */
	getNumberOfDistinctValues() {
		return this.numberOfDistinctValues;
	}

	/**
	 * Sets the value of the numberOfDistinctValues property.
	 * @param {String} value allowed object is {@link String}
	 */
	setNumberOfDistinctValues(value) {
		var oldValue = this.numberOfDistinctValues;
		this.numberOfDistinctValues = value;
		this._setAndNotify(185, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 185, oldValue, value);
	}

	/**
	 * Gets the value of the numberOfNullValues property.
	 * @return {String} possible object is {@link String}
	 */
	getNumberOfNullValues() {
		return this.numberOfNullValues;
	}

	/**
	 * Sets the value of the numberOfNullValues property.
	 * @param {String} value allowed object is {@link String}
	 */
	setNumberOfNullValues(value) {
		var oldValue = this.numberOfNullValues;
		this.numberOfNullValues = value;
		this._setAndNotify(186, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 186, oldValue, value);
	}

	/**
	 * Gets the value of the orderedValues property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isOrderedValues() {
		return this.orderedValues;
	}

	/**
	 * Sets the value of the orderedValues property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setOrderedValues(value) {
		var oldValue = this.orderedValues;
		this.orderedValues = value;
		this._setAndNotify(187, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 187, oldValue, value);
	}

	/**
	 * Gets the value of the hierarchyHasMultipleRoots property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isHierarchyHasMultipleRoots() {
		return this.hierarchyHasMultipleRoots;
	}

	/**
	 * Sets the value of the hierarchyHasMultipleRoots property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setHierarchyHasMultipleRoots(value) {
		var oldValue = this.hierarchyHasMultipleRoots;
		this.hierarchyHasMultipleRoots = value;
		this._setAndNotify(188, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 188, oldValue, value);
	}

	/**
	 * Gets the value of the calculatedMember property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the calculatedMember property. <p> For example, to add a new item, do as follows: <pre> getCalculatedMember().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link CalculatedMemberType}
	 */
	getCalculatedMember() {
		if (!this.calculatedMember) {
			this.calculatedMember = [];
		}
		return this.calculatedMember;
	}

	/**
	 * Gets the value of the rootMember property.
	 * @return {String} possible object is {@link String}
	 */
	getRootMember() {
		return this.rootMember;
	}

	/**
	 * Sets the value of the rootMember property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRootMember(value) {
		var oldValue = this.rootMember;
		this.rootMember = value;
		this._setAndNotify(190, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 190, oldValue, value);
	}

	/**
	 * Gets the value of the members property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the members property. <p> For example, to add a new item, do as follows: <pre> getMembers().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link MemberType}
	 */
	getMembers() {
		if (!this.members) {
			this.members = [];
		}
		return this.members;
	}

	/**
	 * Gets the value of the <code>concepts</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetConcepts() {
		return this.concepts;
	}

	/**
	 * Gets the value of the <code>calculatedMember</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>CalculatedMemberType</code> elements, or <code>null</code> if not set
	 */
	basicGetCalculatedMember() {
		return this.calculatedMember;
	}

	/**
	 * Gets the value of the <code>members</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>MemberType</code> elements, or <code>null</code> if not set
	 */
	basicGetMembers() {
		return this.members;
	}

	/**
	 * Creates a new instance of <code>QueryItem</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> QueryItem</code> object from.
	 * @return {QueryItem} an object of type <code>QueryItem</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createQueryItem();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addConceptsAt(position, item) {
		this._addAtAndNotify(this.getConcepts(), position, item, 182, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addConcepts(item) {
		this.addConceptsAt(this.getConcepts().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeConceptsAt(position) {
		this._removeAtAndNotify(this.getConcepts(), position, 182, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeConcepts(item) {
		var i = this.getConcepts().indexOf(item);
		if (i >= 0) {
			this.removeConceptsAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addCalculatedMemberAt(position, item) {
		this._addAtAndNotify(this.getCalculatedMember(), position, item, 189, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addCalculatedMember(item) {
		this.addCalculatedMemberAt(this.getCalculatedMember().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeCalculatedMemberAt(position) {
		this._removeAtAndNotify(this.getCalculatedMember(), position, 189, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeCalculatedMember(item) {
		var i = this.getCalculatedMember().indexOf(item);
		if (i >= 0) {
			this.removeCalculatedMemberAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addMembersAt(position, item) {
		this._addAtAndNotify(this.getMembers(), position, item, 191, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addMembers(item) {
		this.addMembersAt(this.getMembers().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeMembersAt(position) {
		this._removeAtAndNotify(this.getMembers(), position, 191, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeMembers(item) {
		var i = this.getMembers().indexOf(item);
		if (i >= 0) {
			this.removeMembersAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "QueryItem";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(true, false, false, 182, "concepts", null));
		featureList.push(this.createFeature(false, false, false, 183, "minimumValue", null));
		featureList.push(this.createFeature(false, false, false, 184, "maximumValue", null));
		featureList.push(this.createFeature(false, false, false, 185, "numberOfDistinctValues", null));
		featureList.push(this.createFeature(false, false, false, 186, "numberOfNullValues", null));
		featureList.push(this.createFeature(false, false, false, 187, "orderedValues", null));
		featureList.push(this.createFeature(false, false, false, 188, "hierarchyHasMultipleRoots", null));
		var clazz;
		if (factory) {
			clazz = factory.createCalculatedMemberType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 189, "calculatedMember", clazz));
		featureList.push(this.createFeature(false, false, false, 190, "rootMember", null));
		if (factory) {
			clazz = factory.createMemberType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 191, "members", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 183:
			this.setMinimumValue((value));
			break;
		case 184:
			this.setMaximumValue((value));
			break;
		case 185:
			this.setNumberOfDistinctValues((value));
			break;
		case 186:
			this.setNumberOfNullValues((value));
			break;
		case 187:
			this.setOrderedValues((value));
			break;
		case 188:
			this.setHierarchyHasMultipleRoots((value));
			break;
		case 190:
			this.setRootMember((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 182:
			this.concepts = (value);
			break;
		case 189:
			this.calculatedMember = (value);
			break;
		case 191:
			this.members = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 182:
			return this.getConcepts();
		case 183:
			return this.getMinimumValue();
		case 184:
			return this.getMaximumValue();
		case 185:
			return this.getNumberOfDistinctValues();
		case 186:
			return this.getNumberOfNullValues();
		case 187:
			return this.isOrderedValues();
		case 188:
			return this.isHierarchyHasMultipleRoots();
		case 189:
			return this.getCalculatedMember();
		case 190:
			return this.getRootMember();
		case 191:
			return this.getMembers();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 182:
			return this.basicGetConcepts();
		case 183:
			return this.getMinimumValue();
		case 184:
			return this.getMaximumValue();
		case 185:
			return this.getNumberOfDistinctValues();
		case 186:
			return this.getNumberOfNullValues();
		case 187:
			return this.isOrderedValues();
		case 188:
			return this.isHierarchyHasMultipleRoots();
		case 189:
			return this.basicGetCalculatedMember();
		case 190:
			return this.getRootMember();
		case 191:
			return this.basicGetMembers();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 182:
			this.addConceptsAt(position, (value));
			break;
		case 189:
			this.addCalculatedMemberAt(position, (value));
			break;
		case 191:
			this.addMembersAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 182:
			this.addConcepts((value));
			break;
		case 189:
			this.addCalculatedMember((value));
			break;
		case 191:
			this.addMembers((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 182:
			this.removeConceptsAt(position);
			break;
		case 189:
			this.removeCalculatedMemberAt(position);
			break;
		case 191:
			this.removeMembersAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 182:
			this.removeConcepts((item));
			break;
		case 189:
			this.removeCalculatedMember((item));
			break;
		case 191:
			this.removeMembers((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/QueryItem.js